export default __webpack_public_path__ + "static/media/hejun-news.96b72b04.png";